<div #mainDiv_ll_model_cash_reconcile_switch>

  <div [style.top.px]="bundle.horzTabsY"
       [style.left.px]="bundle.remainingX"
       style="position: absolute;z-index:200">

    <span style="display: inline-block; width: 60px; padding: 5px; font-weight: 500; font-size: small;">
      Month:
    </span>

    <select style="padding: 5px; font-size: small; min-width: 100px;"
            [(ngModel)]="bundle.monthChoice"
            (change)="onMonthChange($event)">

      <option *ngFor="let month of bundle.monthList"
              [value]="month.CHOICE">
        {{ month.LABEL }}
      </option>
    </select>
  </div>

  <div [style.top.px]="bundle.horzTabsY"
       [style.left.px]="bundle.remainingX + 200"
       style="position: absolute;z-index:200">

    <span style="display: inline-block; width: 70px; padding: 5px; font-weight: 500; font-size: small;">
      Location:
    </span>

    <select style="padding: 5px; font-size: small; min-width: 125px;"
            [(ngModel)]="bundle.locationIdChoice"
            (change)="onLocationChange($event)">

      <option *ngFor="let location of bundle.locationList"
              [value]="location.LOCATIONID">
        {{location.LOCATIONNAME }}
      </option>
    </select>
  </div>


  <div [style.top.px]="bundle.horzTabsY"
       [style.left.px]="bundle.remainingX + 650"
       style="position: absolute;z-index:200">

    <span style="display: inline-block; width: 60px; padding: 5px; font-weight: 500; font-size: small;">
      State:
    </span>

    <select style="padding: 5px; font-size: small; min-width: 60px;"
            [(ngModel)]="bundle.stateIdChoice"
            (change)="onStateChange($event)">

      <option *ngFor="let state of bundle.stateList"
              [value]="state.STATEID">
        {{state.STATENAME }}
      </option>
    </select>
  </div>



  <!-- TABS ACROSS THE TOP - ALL IN ONE ROW -->
  <div [hidden]="!bundle.showHorzTabs"
       [style.top.px]="bundle.horzTabsY + 40"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       style="position: absolute;
       z-index: 200;
       display: flex;
       align-items: center;
       flex-wrap: wrap;
            gap: 12px;
            min-height: 38px;
            background: white;
            overflow: hidden;
            padding: 4px 0 8px 0;">

    <!-- General Section -->
    <div *ngFor="let gen of bundle.genTabs; let i = index"
         style="cursor:pointer; white-space: nowrap;"
         (click)="selectTab(gen.CODE)">

      <div *ngIf="gen.CODE === bundle.activeCODE"
           class="wordBtn14_selected"
           style="display: inline-block; padding-right: 6px;">
        {{ gen.LABEL }}
      </div>

      <div *ngIf="gen.CODE !== bundle.activeCODE"
           class="wordBtn14"
           style="display: inline-block; padding-right: 6px;">
        {{ gen.LABEL }}
      </div>
    </div>

    <!-- Bank Section -->
    <div style="font-weight: 600; white-space: nowrap; padding-right: 8px;">
      Bank Matched:
    </div>

    <div *ngFor="let bank of bundle.bankTabs; let i = index"
         style="cursor:pointer; white-space: nowrap;"
         (click)="selectTab(bank.CODE)">

      <div *ngIf="bank.CODE === bundle.activeCODE"
           class="wordBtn14_selected"
           style="display: inline-block; padding-right: 6px;">
        {{ bank.LABEL }}
      </div>

      <div *ngIf="bank.CODE !== bundle.activeCODE"
           class="wordBtn14"
           style="display: inline-block; padding-right: 6px;">
        {{ bank.LABEL }}
      </div>
    </div>

    <!-- Remit Section -->
    <div style="font-weight: 600; white-space: nowrap; padding-left: 20px; padding-right: 8px;">
      Remit Matched:
    </div>

    <div *ngFor="let remit of bundle.remitTabs; let i = index"
         style="cursor:pointer; white-space: nowrap;"
         (click)="selectTab(remit.CODE)">

      <div *ngIf="remit.CODE === bundle.activeCODE"
           class="wordBtn14_selected"
           style="display: inline-block; padding-right: 6px;">
        {{ remit.LABEL }}
      </div>

      <div *ngIf="remit.CODE !== bundle.activeCODE"
           class="wordBtn14"
           style="display: inline-block; padding-right: 6px;">
        {{ remit.LABEL }}
      </div>
    </div>

  </div>

  <div *ngIf="bundle.showSelectAll"
       [style.top.px]="this.bundle.remainingY - 20"
       [style.left.px]="bundle.remainingX"
       style="position: absolute;z-index: 120">

    <div class="wordBtn_12" *ngIf="!bundle.allSelected" (click)="selectAll()">Select All</div>
    <div class="wordBtn_12" *ngIf="bundle.allSelected" (click)="deSelectAll()">Deselect All</div>
  </div>

  <div [hidden]="!bundle.showGrid"
       [style.top.px]="bundle.remainingY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute; z-index: 100">

    <jqxGrid #datagrid_ll_model_cash_reconcile_switch
             [width]="bundle.gridW"
             [height]="bundle.gridH"
             [editable]="true"
             [editmode]="'click'"
             [rowsheight]="20"
             [filterable]="true"
             [sortable]="true"
             [showheader]="true"
             [columnsresize]="true"
             [showstatusbar]="false"
             (onCellvaluechanged)="clickOnRow($event)"
             (onCellclick)="clickOnRow($event)">


    </jqxGrid>

    <div style="padding-top: 10px">

      <!--<div *ngIf="bundle.showDownloadBtn" style="float: left;">-->
      <div class="wordBtn_11" (click)="exportOnClick()">Download Above List</div>
      <!--</div>-->
    </div>

  </div>

  <!-- Custom Draggable USER NOTES Popup -->
  <div id="userNotes"
       *ngIf="showUserNotesPopup"
       [style.top.px]="popupTop"
       [style.left.px]="popupLeft"
       style="position: absolute; z-index: 1000; width: 500px; background: white; border: 1px solid #999;
            border-radius: 6px; box-shadow: 0 8px 25px rgba(0,0,0,0.3); overflow: hidden;">

    <!-- Draggable Header -->
    <div class="popup-header"
         (mousedown)="startDragging($event)">
      <span>Bank Cash User Notes</span>
      <button class="close-btn" (click)="closeUserNotes()" style="background:none; border:none; font-size:18px; cursor:pointer;">×</button>
    </div>

    <!-- Content -->
    <div style="padding: 15px;">
      <div class="form-row">
        <label class="form-label">Category:</label>
        <select class="form-input form-select"
                [ngModel]="cashUserChoiceId"
                (ngModelChange)="newCASHUSERCHOICEID($event)">
          <option value="" disabled *ngIf="!cashUserChoiceId">Select Category...</option>
          <option *ngFor="let opt of bundle.userChoices" [value]="opt.CASHUSERCHOICEID">
            {{ opt.CASHUSERCHOICE }}
          </option>
        </select>
      </div>

      <div class="form-row">
        <label class="form-label">New Note:</label>
        <div style="flex: 1;">
          <textarea class="form-input loan-text-input"
                    (input)="newUserNote($event)"
                    placeholder="Type New Note"
                    style="height: 50px; overflow-y: auto; resize: none; width: 100%; min-height: 50px;">
        </textarea>
        </div>
      </div>

      <div class="form-row">
        <label class="form-label">Past Notes:</label>
        <div style="flex: 1;">
          <div *ngIf="!bundle.canManualMatch" class="form-input loan-text-input past-notes-display"
               [innerHTML]="getUserNotes"
               style="height: 150px; overflow-y: auto; overflow-x: hidden; padding: 8px 12px;
                    white-space: pre-wrap; word-break: break-word; background-color: #f9f9f9;">
          </div>
          <div *ngIf="bundle.canManualMatch" class="form-input loan-text-input past-notes-display"
               [innerHTML]="getUserNotes"
               style="height: 100px; overflow-y: auto; overflow-x: hidden; padding: 8px 12px;
                white-space: pre-wrap; word-break: break-word; background-color: #f9f9f9;">
          </div>
        </div>
      </div>

      <div class="form-row" *ngIf="bundle.canManualMatch" >
        <label class="form-label">Manual Select Remit:</label>
        
      </div>



    </div>

    <div style="padding: 12px 15px; background: #f5f5f5; border-top: 1px solid #ddd;
            display: flex; justify-content: space-between; align-items: center;">

      <button class="wordBtn14" (click)="closeUserNotes()">Cancel</button>
      <button class="wordBtn14" (click)="saveUserNotes()">Save</button>
    </div>
  </div>

  <!-- Custom Draggable EDIT LOC Popup -->
  <div id="editLoc"
       *ngIf="showEditLocPopup"
       [style.top.px]="popupTop_editLoc"
       [style.left.px]="popupLeft_editLoc"
       style="position: absolute; z-index: 1000; width: 500px; background: white; border: 1px solid #999;
           border-radius: 6px; box-shadow: 0 8px 25px rgba(0,0,0,0.3); overflow: hidden;">

    <!-- Draggable Header -->
    <div class="popup-header"
         (mousedown)="startDragging_editLoc($event)">
      <span>Location Edit</span>
      <button class="close-btn" (click)="closeEditLoc()" style="background:none; border:none; font-size:18px; cursor:pointer;">×</button>
    </div>

    <!-- Content -->
    <div style="padding: 15px;">
      <div class="form-row">
        <label class="form-label">New Account:</label>
        <select class="form-input form-select"
              
                (change)="newLOCATIONACCOUNTID($event.target.value)">
          <option value="" >Select Location...</option>
          <option *ngFor="let opt of bundle.bankAccountList" [value]="opt.CASHBANKLOCATIONACCOUNTID">
            {{ opt.SUMMARY }}
          </option>
        </select>
      </div>

    </div>

    <div style="padding: 12px 15px; background: #f5f5f5; border-top: 1px solid #ddd;
           display: flex; justify-content: space-between; align-items: center;">

      <button class="wordBtn14" (click)="closeEditLoc()">Cancel</button>
      <button class="wordBtn14" (click)="saveEditLoc()">Save</button>
    </div>
  </div>


</div>

